import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '朋睿的服務收費方式為何？',
      answer: '我們採用成功收費制，只有在媒合成功、資金到位後才收取服務費用。初步諮詢與評估完全免費，讓您零風險了解我們的服務。具體收費標準會根據案件規模與複雜度而定，我們會在服務前與您充分溝通並簽訂合約。'
    },
    {
      question: '從諮詢到資金到位需要多久時間？',
      answer: '一般而言，整個流程平均需要 30-45 天。但實際時間會因案件複雜度、資金規模、企業狀況等因素而有所不同。我們會在初步評估後，為您提供更精確的時程規劃。我們的目標是在確保品質的前提下，盡可能縮短媒合時間。'
    },
    {
      question: '什麼樣的企業適合使用朋睿的服務？',
      answer: '我們服務各種規模與產業的企業，從新創公司到成熟企業都適合。無論您需要的是種子資金、成長資金、擴張資金或併購融資，我們都能提供協助。只要您的企業具有清晰的商業模式、合理的財務狀況，以及明確的資金用途，我們都歡迎您來諮詢。'
    },
    {
      question: '朋睿與一般銀行或創投有什麼不同？',
      answer: '朋睿是專業的資金媒合平台，我們本身不提供資金，而是協助您找到最適合的資金來源。相較於直接向銀行或創投申請，透過朋睿的優勢在於：1) 我們整合多元資金管道，提供更多選擇；2) 我們協助優化您的申請文件與簡報；3) 我們了解各資金方的偏好，提高媒合成功率；4) 我們提供全程顧問服務，大幅節省您的時間與精力。'
    },
    {
      question: '如果媒合不成功怎麼辦？',
      answer: '如果首次媒合未能成功，我們會與您深入討論原因，並提供改善建議。我們會持續為您尋找其他適合的資金方，直到找到最佳方案。由於我們採成功收費制，媒合不成功您不需要支付任何費用。我們的目標是與您建立長期合作關係，而非一次性交易。'
    },
    {
      question: '資金方會如何評估我的企業？',
      answer: '資金方通常會評估以下面向：1) 商業模式的可行性與市場潛力；2) 財務狀況與獲利能力；3) 管理團隊的經驗與能力；4) 產業競爭力與成長性；5) 資金用途的合理性。我們會在媒合前協助您準備完整的資料，並提供專業建議，提高獲得資金的機會。'
    },
    {
      question: '我可以同時尋求多個資金來源嗎？',
      answer: '可以的。事實上，我們經常建議客戶保持多元化的資金策略。不同的資金來源各有優缺點，例如銀行融資成本較低但審核嚴格，創投資金則可能帶來產業資源但會稀釋股權。我們會根據您的需求與狀況，為您規劃最適合的資金組合方案。'
    }
  ];

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">常見問題</h2>
          <div className="w-20 h-1 bg-[#1a5f7a] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            以下是客戶最常詢問的問題，如有其他疑問歡迎隨時與我們聯繫
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <h4 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h4>
                <i
                  className={`text-2xl text-[#1a5f7a] transition-transform flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gray-50 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">還有其他問題？</h3>
          <p className="text-gray-600 mb-6">
            我們的專業顧問團隊隨時為您解答任何疑問
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://line.me/R/ti/p/@678gwbht"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-[#1a5f7a] text-white rounded-lg font-semibold hover:bg-[#164d61] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-line-fill mr-2 text-lg"></i>
              LINE 諮詢
            </a>
            <a
              href="tel:02-27951331"
              className="inline-flex items-center px-6 py-3 bg-white text-[#1a5f7a] border-2 border-[#1a5f7a] rounded-lg font-semibold hover:bg-[#1a5f7a] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-lg"></i>
              電話諮詢
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
